import React from "react";
import { portfolioData } from "../data/portfolioData";

const Footer = () => {
  return (
    <footer className="border-t border-slate-200 bg-white/90 py-6 text-sm text-slate-600 backdrop-blur">
      <div className="mx-auto grid max-w-6xl gap-5 px-4 md:grid-cols-2 md:px-6">
        <div>
          <p className="text-base font-semibold text-slate-900">{portfolioData.name}</p>
          <p className="text-sm text-slate-700">{portfolioData.role}</p>
          <p className="mt-2 text-sm">
            Email:{" "}
            <a href={`mailto:${portfolioData.email}`} className="font-medium text-indigo-700">
              {portfolioData.email}
            </a>
          </p>
          <p className="mt-2 text-xs text-slate-500">
            Copyright {new Date().getFullYear()} {portfolioData.name}
          </p>
        </div>
        <div className="flex items-start gap-5 md:justify-end">
          <a
            href={portfolioData.linkedin}
            target="_blank"
            rel="noreferrer"
            className="font-medium text-indigo-700 transition hover:text-indigo-600"
          >
            LinkedIn
          </a>
          <a
            href={portfolioData.github}
            target="_blank"
            rel="noreferrer"
            className="font-medium text-indigo-700 transition hover:text-indigo-600"
          >
            GitHub
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
